import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { DelayedDispatchService } from '../../service/delayed-dispatch.service';
import { AppMessage } from '../../model/messages.model';
import { ToastMessageOptions } from 'primeng/api';

@Component({
    selector: 'app-allo-history',
    templateUrl: './allo-history.component.html',
    styleUrls: ['./allo-history.component.css'],
    standalone: false // NOSONAR
})
export class AlloHistoryComponent implements OnInit {

  errMsgs: ToastMessageOptions[]= [];
  updatedProperties: any;
  userReportsHistory: any;
  alloPropCols: any;
  alloReportCols: any;
  filters: any;

  constructor(private readonly service: DelayedDispatchService, 
    private readonly spinnerService: NgxSpinnerService,
    private readonly pipe: DatePipe) { }

  ngOnInit() { // NOSONAR
    this.alloPropCols = [
      { field: 'domicile', header: 'Domicile' },
      { field: 'propType', header: 'Type' },
      { field: 'propName', header: 'Name' },
      { field: 'currentPropValue', header: 'Value' },
      { field: 'createdBy', header: 'Created By' },
      { field: 'createdDate', header: 'Created Date' },
      { field: 'updatedBy', header: 'Updated By' },
      { field: 'updatedDate', header: 'Updated Date' }
    ];
    this.alloReportCols = [
      { field: 'userName', header: 'User' },
      { field: 'period', header: 'Period' },      
      { field: 'domicile', header: 'Domicile' },
      { field: 'reportName', header: 'Report Name' },
      { field: 'reportStatus', header: 'Report Status' },
      { field: 'startDateTime', header: 'Start Date' },
      { field: 'endDateTime', header: 'End Date' },
    ];
    this.getUpdatedProperties();
    this.getUserReportsHistory();
  }

  getUpdatedProperties() {
    this.spinnerService.show();
    this.service.getUpdatedAlloProperties().subscribe(
      (data: any) => {
        this.spinnerService.hide();
        if (data.messages != undefined && data.messages.length != 0) { // NOSONAR
          this.messageHandler(data);
        } else {
          this.updatedProperties = data;
        }
      },
      (error: any) => {
        this.spinnerService.hide();
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });

      }
    );
  }

  getUserReportsHistory() {
    this.spinnerService.show();
    this.service.getUserReportsHistory().subscribe(
      (data: any) => {
        if (data.messages != undefined && data.messages.length != 0) {
          this.messageHandler(data);
        } else {
          this.userReportsHistory = data;
        }
        this.spinnerService.hide();
      },
      (error: any) => {
        this.errMsgs = [];
        this.errMsgs.push({ severity: 'error', summary: error.message, detail: '' });
        this.spinnerService.hide();
      }
    );
  }

  messageHandler(data) {
    this.messageHandlerType(data, 'error');
  }

  messageHandlerType(data, type) {
    this.errMsgs = [];
    if (data.messages != undefined && data.messages.length != 0) { // NOSONAR
      for (const entry of data.messages) {
        for (const mes of entry.message.sort()) {
          this.setMessage(type, mes);
        }
      }
      return;
    }
  }

  setMessage(type, desc) {
    this.errMsgs = [];
    this.errMsgs.push({ severity: type, summary: desc, detail: '' });

  }

  filterCapture(_event, data) {
    this.filters = data.filters;
  }

  formatDate(dt) {
    return this.pipe.transform(dt, 'MM/dd/yyyy HH:mm', 'EST');
  }
}
